import * as React from 'react';
import styled from 'styled-components';
import {
  space,
  color,
  width,
  border,
  height,
  display,
  minWidth,
  maxWidth,
  alignItems,
  borderRadius,
  justifyContent,
  alignSelf,
  flex,
  background,
  borderColor,
} from 'styled-system';
import { StyledSystemProps } from '../theme/StyledSystemProps';
import { Loader } from '.';
import Box from './primitives/Box';
import { theme } from '../theme';

interface ButtonProps extends StyledSystemProps {
  text?: string;
  size?: string;
  loaderColor?: string;
  borderColor?: string;
  hover?: boolean;
  isIcon?: boolean;
  minimal?: boolean;
  outline?: boolean;
  disabled?: boolean | null;
  isLoading?: boolean;
  onClick?: () => void;
  icon?: React.ReactNode;
  type: 'button' | 'submit' | 'reset';
  open?: boolean;
  disabledTitle?: string;
  title?: string;
}

const StyledButton = styled.button`
  ${flex};
  ${space};
  ${width};
  ${color};
  ${border};
  ${background};
  ${height};
  ${display};
  ${maxWidth};
  ${alignSelf};
  ${alignItems};
  ${borderRadius};
  ${justifyContent};
  ${borderColor};
  ${(props: ButtonProps) => !props.isIcon && minWidth};
  outline: none;
  cursor: pointer;
  border-style: solid;
  &:hover {
    box-shadow: ${(props: ButtonProps) =>
      props.bg === 'transparent' || props.minimal ? 'none' : '0 1px 4px rgba(50,50,93,0.4)'};
    background: ${(props: ButtonProps) => props.minimal && 'rgba(50,50,93,0.05)'};
    transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    transform: ${(props: ButtonProps) => props.hover && 'translateY(-1px)'};
    cursor: pointer;
  }
  &:hover > * {
    cursor: pointer;
  }
  &:disabled {
    background-color: #ababab;
    border-color: #ababab;
    cursor: not-allowed;
  }
  &:disabled > * {
    cursor: not-allowed;
  }
`;

const Button: React.FC<ButtonProps> = (props) => {
  const { isLoading, disabled, text, loaderColor, icon } = props;
  return (
    <StyledButton
      disabled={isLoading || disabled}
      {...props}
      title={props.disabled ? props.disabledTitle : props.title}
    >
      <Box flexDirection="row" alignItems="center" justifyContent="space-evenly">
        {isLoading ? <Loader width={20} color={loaderColor} height={20} /> : text}
        {!isLoading && icon && icon}
      </Box>
    </StyledButton>
  );
};

Button.defaultProps = {
  icon: null,
  size: 'md',
  bg: 'putty',
  color: '#FFF',
  width: '100%',
  outline: false,
  height: '40px',
  minimal: false,
  text: 'Button',
  borderColor: theme.colors.putty,
  isLoading: false,
  p: '0.25em 1.2em',
  minWidth: '150px',
  borderRadius: '4px',
  justifyContent: 'center',
  boxShadow: '0 1px 3px rgba(50,50,93,0.2)',
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/Button.tsx